import { render, staticRenderFns } from "./tech_detail.vue?vue&type=template&id=df1355ee"
import script from "./tech_detail.vue?vue&type=script&lang=js"
export * from "./tech_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports